import Index from '@tunnel-components/@pages/administration/users/container'


/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/users/index.ts